<template>
  <div class="page page--home">
    <div class="details">
      <h2>Take your sales to the next level.</h2>
      <p>Automate your Poshmark business with a fully controllable virtual assistant. Continuously share  of your closet,
        and run sales across your entire closet and even run a clearance sale on your old inventory.</p>
      <p>Designed by a Poshmark seller because nothing else met her needs, our virtual assistant is the difference between being a side-hustle and a full-time business-owner.</p>
      <div class="call-to-action">
        <a class="control">Get Started free for the first week</a>
        <p class="note">Then just $39/month</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
  },
};
</script>
